import React from 'react'

import {
    StyledKicker,
    StyledText,
    KickerPosition,
    StyledPremiumIcon,
} from 'component-library/cards/Kicker/Kicker.styled'
import { IconVideo2 } from 'component-library/icons/IconVideo2/IconVideo2'
import { IconCamera } from 'component-library/icons/IconCamera/IconCamera'
import { LiveLabel } from 'component-library/typography/LiveLabel/LiveLabel'
import { PublicationType } from 'common/client-data-types/publication'

import { colors } from 'component-library/__styling/settings'
import { Product } from 'component-library/__product'
import { useProduct } from 'common/hooks/useProduct'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export interface Props {
    isLive: boolean
    showVideoIcon: boolean
    isLarge?: boolean
    className?: string
    position?: KickerPosition
    publicationKind?: PublicationType['kind']
    verticalSpacing?: keyof ThemeMargins | undefined
    hasBackground?: boolean
    isPremium?: boolean
    fullWidthOnMobile?: boolean
}

const iconWidth = 17
const iconVideoHeight = 9
const iconCameraHeight = 12
const iconPremiumHeight = 17
const iconSpacing = 6

export const Kicker: React.FC<Props> = ({
    className,
    isLive,
    isLarge,
    showVideoIcon: hasHeroVideo,
    children,
    position,
    verticalSpacing,
    publicationKind,
    hasBackground,
    isPremium,
}) => {
    const product = useProduct()

    return (
        <StyledKicker
            className={className}
            isLive={isLive}
            isLarge={isLarge}
            position={position}
            verticalSpacing={verticalSpacing}
            hasBackground={hasBackground}
        >
            {isLive ? (
                <LiveLabel isLarge={isLarge} />
            ) : (
                renderNotLiveLabel(product, children, hasHeroVideo, publicationKind)
            )}
            {isPremium && <StyledPremiumIcon width={iconWidth} height={iconPremiumHeight} />}
        </StyledKicker>
    )
}
Kicker.displayName = 'Kicker'

function getPublicationIcon(
    publicationKind: string | undefined,
    hasHeroVideo?: boolean
): React.ReactNode {
    if (publicationKind === 'gallery') {
        return (
            <IconCamera
                width={iconWidth}
                height={iconCameraHeight}
                horizontalSpacing={iconSpacing}
                fill={colors.thewest.greyHippo}
            />
        )
    }

    if (publicationKind === 'video' || hasHeroVideo) {
        return (
            <IconVideo2
                width={iconWidth}
                height={iconVideoHeight}
                horizontalSpacing={iconSpacing}
                fill={colors.thewest.greyHippo}
            />
        )
    }

    return
}

function renderNotLiveLabel(
    product: Product,
    children: React.ReactNode,
    hasHeroVideo: boolean,
    publicationKind?: string | undefined
): React.ReactNode {
    if (product === 'perthnow' || product === 'sevennews') {
        return <StyledText isLive={false}>{children}</StyledText>
    }

    const icon = getPublicationIcon(publicationKind, hasHeroVideo)

    return (
        <StyledText isLive={false}>
            {children}
            {icon && icon}
        </StyledText>
    )
}
